export default __webpack_public_path__ + "static/media/napiergrass.e2701723.png";